export default "__VITE_ASSET__CnjL$n$t__"